import { z } from "zod";
const id = z.string().min(1).max(240);
const digest = z.string().regex(/^[a-f0-9]{64}$/u);
const money = z.object({ currency: z.literal("USD"), amountMinor: z.number().int() }).strict();
export const staffCaseRoleV1Schema = z.enum(["ADMIN", "SUPPORT_AGENT"]);
export const staffCaseAssetV1Schema = z.union([
    z.literal("COVER"),
    z.literal("INTERIOR"),
    z.object({ pageId: id }).strict(),
]);
export const staffCaseBookSummaryV1Schema = z
    .object({
    contract: z.literal("LC_STAFF_CASE_BOOK_SUMMARY_V1"),
    scope: z.object({ customerId: id, bookId: id, ticketId: id.nullable() }).strict(),
    identity: z
        .object({
        family: z.enum(["BEDTIME", "MY_STORY", "OUR_STORY", "COOKBOOK", "COMIC"]),
        sourceRevision: z.number().int().nonnegative().nullable(),
        editionId: id.nullable(),
        proofId: id.nullable(),
        packageId: id.nullable(),
        physicalOrderId: id.nullable(),
        fulfillmentId: id.nullable(),
    })
        .strict(),
    edition: z
        .object({
        state: z.enum(["AVAILABLE", "LEGACY_EVIDENCE_UNAVAILABLE", "UNKNOWN"]),
        immutable: z.boolean(),
        profileId: id.nullable(),
        profileVersion: id.nullable(),
        files: z
            .array(z
            .object({
            asset: z.enum(["COVER", "INTERIOR"]),
            checksumSha256: digest,
            pageCount: z.number().int().positive(),
            exactVersionRetained: z.boolean(),
        })
            .strict())
            .max(2),
    })
        .strict(),
    order: z
        .object({
        state: z.enum(["AVAILABLE", "NOT_REQUESTED", "UNKNOWN"]),
        quantity: z.number().int().positive().nullable(),
        includedCopyQuantity: z.number().int().nonnegative().nullable(),
        orderRecordState: z.enum(["EVIDENCE_READY", "ACTIVE", "CANCELLED", "ARCHIVED"]).nullable(),
        fulfillmentState: id.nullable(),
        provider: z.enum(["GELATO", "LULU", "OTHER_REVIEWED", "LIFESCAPSULE_SIMULATOR"]).nullable(),
        providerEnvironment: z.enum(["SANDBOX", "PRODUCTION"]).nullable(),
        lastProviderObservedAt: z.string().datetime({ offset: true }).nullable(),
    })
        .strict(),
    economics: z
        .object({
        cost: z
            .object({
            state: z.enum(["SETTLED_ACTUAL", "RESERVED_OR_QUOTED", "RELEASED", "UNKNOWN"]),
            value: money.nullable(),
            evidenceDigestSha256: digest.nullable(),
        })
            .strict(),
        price: z
            .object({
            state: z.enum(["TEST_PAID_REORDER", "ORIGINAL_ENTITLEMENT_OFFER", "UNKNOWN"]),
            value: money.nullable(),
            test: z.boolean().nullable(),
        })
            .strict(),
        profit: z
            .object({
            completeness: z.enum(["TEST_ONLY_COMPLETE", "INCOMPLETE"]),
            contribution: money.nullable(),
            missingSources: z.array(id).max(10),
            truthBoundary: z.literal("CONTRIBUTION_NOT_ACCOUNTING_PROFIT"),
        })
            .strict(),
    })
        .strict(),
    truthBoundary: z.literal("CASE_SCOPED_ENGINE_FACTS_NO_MANUSCRIPT_BODY_ADDRESS_PROVIDER_IDS_OR_PRINT_PERMISSION"),
})
    .strict();
export const staffCaseFileTicketV1Schema = z
    .object({
    contract: z.literal("LC_STAFF_CASE_FILE_TICKET_V1"),
    bookId: id,
    physicalOrderId: id.nullable(),
    proofId: id.nullable(),
    asset: staffCaseAssetV1Schema,
    checksumSha256: digest,
    downloadUrl: z
        .string()
        .url()
        .refine((value) => new URL(value).protocol === "https:"),
    expiresAt: z.string().datetime({ offset: true }),
    expiresInSeconds: z.literal(300),
    auditEventDigestSha256: digest,
    truthBoundary: z.literal("SHORT_LIVED_CASE_SCOPED_EXACT_VERSION_NO_RAW_STORAGE_KEY"),
})
    .strict();
//# sourceMappingURL=book-staff-case-context.js.map